import React from 'react';

const BlueCircleButton = ({ onClicked, plusSign }) => (
  <button
    style={{
      backgroundColor: '#015cb0',
      borderRadius: '50%',
      width: '45px',
      height: '45px',
      color: 'white',
      fontSize: '24px',
      textAlign: 'center',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    onClick={onClicked}
    aria-label="Toggle table"
  >
    {plusSign ? (
      <svg width="18" height="18" style={{ display: 'block' }}>
        <line x1="2" y1="9" x2="16" y2="9" stroke="white" strokeWidth="2" />
        <line x1="9" y1="2" x2="9" y2="16" stroke="white" strokeWidth="2" />
      </svg>
    ) : (
      <svg width="18" height="3" style={{ display: 'block' }}>
        <rect x="0" y="1" width="30" height="4" rx="1" fill="white" />
      </svg>
    )}
  </button>
);

export default BlueCircleButton;
